import { AnyAction } from '@reduxjs/toolkit';
import { combineEpics, StateObservable } from 'redux-observable';
import { catchError, filter, Observable, of, switchMap } from 'rxjs';
import { DEFAULT_GAME_LANGUAGE } from '../../../../Utils/Constants';
import { mapPayload } from '../../../../Utils/RxjsOperators/MapPayload';
import WidgetFrontActions from '../../Pages/WidgetFront/WidgetFrontActions';
import { StoreDependencies } from '../StoreDependencies';
import { StoreState } from '../StoreState';
import UserStoreActions from '../User/UserStoreActions';
import VideoAnalysisActions from '../VideoAnalysis/VideoAnalysisActions';

function collectMoonWithReadText(
  $action: Observable<AnyAction>,
  $state: StateObservable<StoreState>,
  dependencies: Partial<StoreDependencies>
): Observable<AnyAction> {
  return $action.pipe(
    filter(VideoAnalysisActions.setPredictedMoonName.match),
    mapPayload(),
    filter((moonName) => moonName.length > 0),
    switchMap((moonName) =>
      dependencies.moonManager!.predictMoonWithName(
        moonName,
        $state.value.user.currentUser?.settings.smoLanguage ?? DEFAULT_GAME_LANGUAGE
      )
    ),
    filter((prediction) => !!prediction),
    switchMap((prediction) => dependencies.userManager!.collectMoonWithId(prediction!.moon.id)),
    switchMap((run) => [UserStoreActions.setCurrentUserRun(run), WidgetFrontActions.updateRun(run)]),
    catchError(() => of(UserStoreActions.setCurrentUserRun(undefined)))
  );
}

export default combineEpics(collectMoonWithReadText);
